import queryString from 'query-string';

common.View.create('shop::website.modules.shopProducts.Index', {

    currentLoadHtmlAjax: null,

    onDOMLoad()
    {
        this.initPopState();
    },

    initPopState()
    {
        // Listen for pop state.
        window.addEventListener('popstate', event =>
        {
            //
            this.getInstances().filters.setByUrl();

            //
            this.loadHtml(true);
        });
    },

    onUserInput()
    {
        //
        this.loadHtml(false);
    },

    async loadHtml(isBack)
    {
        // Cancel current request?
        if (this.currentLoadHtmlAjax)
        {
            this.currentLoadHtmlAjax.abort();

            this.currentLoadHtmlAjax = null;
        }

        // Show products as loading.
        this.getInstances().products.setLoading();

        // Update url?
        let url = this.getUrlByState();

        if (!isBack && history.pushState)
            history.pushState(null, $('head title').text(), url);

        // Request
        this.currentLoadHtmlAjax = $.get(url);

        try {
            var response = $(await this.currentLoadHtmlAjax);
        }
        catch(ex) {
            // Abort due to aborted on purpose?
            if(ex?.statusText == 'abort')
                return;

            // Rethrow?
            else
                throw ex;
        }

        // Update HTML's.

        // Categories aren't always shown, so check if they are shown
        let categories = this.getInstances().categories
        if(categories)
            categories.updateHtml(response);

        this.updateHtml(response);
        this.getInstances().products.updateHtml(response);
        this.getInstances().filters.updateHtml(response);
    },

    updateHtml(ajaxResponse)
    {
        // Replace HTML.
        this.element.find('.productCount').replaceWith(ajaxResponse.find('.shop\\:\\:website-modules-shopProducts-Index .productCount'));

        //
        common.View.reinit();
    },

    getUrlByState()
    {
        // Build query.
        let query = {
            ...this.getInstances().filters.getFilterQuery(),
            ...this.getInstances().brands?.getFilterQuery(),
            ...this.getInstances().sort.getSortQuery(),
        };

        // Build url due to having query?
        if(Object.keys(query).length)
            return '?' + queryString.stringify(query);

        // Use default url without query?
        else
            return document.location.pathname;
    },

    getInstances()
    {
        return {
            categories: this.element.find('.shop\\:\\:website-modules-shopProducts-index-filters-Categories').data('instance'),
            filters: this.element.find('.shop\\:\\:website-modules-shopProducts-index-Filters').data('instance'),
            brands: this.element.find('.shop\\:\\:website-modules-shopProducts-index-filters-Brands').data('instance'),
            products: this.element.find('.shop\\:\\:website-modules-shopProducts-index-Products').data('instance'),
            sort: this.element.find('.shop\\:\\:website-modules-shopProducts-index-Sort').data('instance'),
        };
    },

});
